<template>
     <span v-if="hasTranslation">
      
      <v-select
                v-bind="$attrs"
                :modelValue="modelValue"
                v-model="selectStatus"
                :label="labelText"
                :items="items"
                :item-title="itemTitle"
                :item-value="itemValue"
                :item-props="itemProps"
                :loading="loading"
                :hint="hintText"
                :persistent-hint="persistentHint"
                :active="active"
                :autofocus="autofocus"
                :bg-color="bgColor"
                :base-color="baseColor"
                :variant="variant"
                @update:modelValue="updateModel"
                @input="$emit('update:modelValue', $event.target.value)"

              />    
     <!-- @input="$emit('update:modelValue', $event.target.value)" -->
    </span>
</template>

<script>
import adminStore from '@/stores/adminstore'
import { mapActions, mapState, mapGetters } from 'pinia'
import { defineModel } from 'vue'

// import { defineAsyncComponent } from 'vue'

export default {
  name: 'I18nSelect',
  components: {},
  emits: ['update:modelValue'],
  props: {
    modelValue: {},
    i18nlabel: {
        type: String,
        required: true
    },
    i18nhint: {
        type: String,
        required: false,
        default: ''
    },
    persistentHint: {
        type: Boolean,
        required: false,
        default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    active: {
        type: Boolean,
        required: false,
        default: true
    },
    autofocus: {
        type: Boolean,
        required: false,
        default: false
    },
    bgColor: {
        type: String,
        required: false,
        default: 'var(--color-white)'
    },
    baseColor: {
        type: String,
        required: false,
        default: 'var(--color-white)'
    },
    variant: {
        type: String,
        required: false,
        default: 'solo'
    },
    items: {
      type: Object,
      required: true
    },
    itemTitle: {
      type: String,
      required: false,
      default: 'title'
    },
    itemValue: {
      type: String,
      required: false,
      default: 'value'
    },
    itemProps: {
      type: Boolean,
      required: false,
      default: true
  }
  },
  data() {
    return {
        labelText: '',
        hintText: '',
        hasTranslation: false,
        inputValue: '', //defineModel(),
        value: '',
        selectStatus: ''
    }
  },
  beforeMount() {
    console.log('i18nSelect GOT BEFORE MOUNT !')
  },
  mounted() {
   // console.log('Label (%s)', this.i18nlabel)
    // console.log('HING (%s)', this.i18nhint)
      this.geti18nTranslation(this.i18nlabel).then(result => {
       // console.log('i18nSELECT TRANSLATE TEXT (%s)', result)
            this.labelText = result
            this.geti18nTranslation(this.i18nhint).then(res2 => {
              this.hintText = res2
              this.hasTranslation = true
            })
       })
  },
  methods: {
    ...mapActions(adminStore, ['geti18nTranslation']),
    ...mapGetters(adminStore,['getTranslationMap']),
    updateModel() {
      console.log('Select updateModel got called (%s)', this.selectStatus)
      this.$emit('update:modelValue', this.selectStatus)
    }
  }
}
</script>

<style scoped>

</style>